module.exports = __webpack_public_path__ + "img/banner_vn.2b27db0a.png";